<template>
    <div class="overview-content">
        <ul class="over-cnt-list">
            <li class="over-cnt-item" v-for="(item, idx) in statDatas" :key="idx">
                <i class="over-cnt-icon" :style="{ background: item.icon }"></i>
                <div class="over-cnt-norm">
                    <div class="over-norm-num">{{ item.value }}</div>
                    <div class="over-norm-label">{{ item.label }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "DataList",
    props: ["data"],
    created() {},
    computed: {
        statDatas() {
            const datas = ["visitedCount", "userCount", "questionsNum", "identifyQuesRate", "robotInterceptRate"];

            return datas.map(norm => {
                return {
                    icon: this.config[norm].icon,
                    label: this.config[norm].label,
                    value: this.data ? this.data[norm] : 0
                };
            });
        },
        config() {
            return {
                visitedCount: {
                    icon: "url(" + this.zhiji.staticPath() + "overview-spr.png) 0 0",
                    label: this.$t("zhiji.overview.visitTimesPv")
                },
                userCount: {
                    icon: "url(" + this.zhiji.staticPath() + "overview-spr.png) -60px 0",
                    label: this.$t("zhiji.overview.visitCount")
                },
                questionsNum: {
                    icon: "url(" + this.zhiji.staticPath() + "overview-spr.png) -120px 0",
                    label: this.$t("zhiji.overview.questionsNum")
                },
                identifyQuesRate: {
                    icon: "url(" + this.zhiji.staticPath() + "overview-spr.png) -240px 0",
                    label: this.$t("zhiji.robotMonitor.replyRate")
                },
                robotInterceptRate: {
                    icon: "url(" + this.zhiji.staticPath() + "overview-spr.png) -240px 0",
                    label: this.$t("zhiji.overview.interceptRate")
                }
            };
        }
    }
};
</script>

<style lang="scss" scope>
.overview-content {
    border-top: 1px solid #ebeef5;

    .over-cnt-list {
        display: flex;
        align-items: center;
    }

    .over-cnt-item {
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: row;
        padding: 37px 8px 29px 8px;
        justify-content: center;
        .over-cnt-norm {
            display: flex;
            flex-direction: column;
        }
        &:after {
            content: "";
            width: 1px;
            height: 93px;
            background: #ebeef5;
            position: absolute;
            right: 0;
        }
        &:last-child {
            &:after {
                display: none;
            }
        }
    }

    .over-cnt-icon {
        width: 56px;
        height: 56px;
        margin-right: 16px;
        display: none;
    }

    .over-norm-num {
        font-size: 26px;
        color: #41475e;
        line-height: 1.2;
    }

    .over-norm-label {
        font-size: 14px;
        color: #9b9ba3;
    }
}
</style>
